if (!customElements.get('harness-fit-video')) {
  customElements.define('harness-fit-video', class extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-fit-open]');
      this.panel = this.querySelector('.harness-fit-video__panel');
      this.closeButton = this.querySelector('[data-fit-close]');
      this.video = this.querySelector('video');
      this.openHandler = () => this.panel.hidden ? this.open() : this.close();
      this.closeHandler = () => this.close();
      this.keyHandler = (event) => {
        if (event.key === 'Escape' && !this.panel.hidden) this.close();
      };
      this.trigger?.addEventListener('click', this.openHandler);
      this.closeButton?.addEventListener('click', this.closeHandler);
      this.addEventListener('keydown', this.keyHandler);
    }

    disconnectedCallback() {
      this.trigger?.removeEventListener('click', this.openHandler);
      this.closeButton?.removeEventListener('click', this.closeHandler);
      this.removeEventListener('keydown', this.keyHandler);
      this.video?.pause();
    }

    open() {
      this.panel.hidden = false;
      this.trigger.setAttribute('aria-expanded', 'true');
      this.video?.play().catch(() => {});
    }

    close() {
      this.video?.pause();
      this.panel.hidden = true;
      this.trigger.setAttribute('aria-expanded', 'false');
      this.trigger.focus();
    }
  });
}
